<template>
  <div class="con-wrap p10">
    <div class="DgrayBg yregister">
      <div class="w1200 flow">
        <h2>域名注册</h2>
        <ul>
          <li>
          <i class="step">1</i>添加清单</li>
          <li>
          <i class="step">2</i>确认订单</li>
          <li>
          <i class="step">3</i>在线支付</li>
          <li>
          <i class="step">4</i>支付成功</li>
        </ul>
      </div>
    </div>

    <div class="success-wrap clearfix">
      <div class="suc-info fl tl">
        <div class="suc-icon clearfix">
          <i class="el-icon-circle-check-outline fl"></i>
          <span class="f36 b green">付款成功！</span>
        </div>

        <div class="suc-con mt30">
          <div class="suc-line f14 lh20 pb5">
            <span class="fc666">
              订单编号：{{orderCode}}
            </span>
          </div>
          <div class="suc-line f14 lh20 pb5">
            <span class="fc666">
              订单金额：<span class="orange">¥{{order.reailCost}}</span>
            </span>
          </div>
          <div class="suc-line f14 lh20 pb5">
            <span class="fc666">
              付款时间：{{order.payTime}}
            </span>
          </div>
          <div class="suc-line f14 lh20 pb5">
            <paySuccessBtn :orderCode='orderCode'></paySuccessBtn>
          </div>
        </div>
      </div>
      <div class="contact-info fr">
        <p class="f14 b">如果您有任何问题，可以联系客服</p>
        <p class="f14 b">
          <i class="el-icon-phone"></i>7x24小时客服热线：400-660-5555
        </p>
      </div>
    </div>

  </div>
</template>
<script>
import PaySuccessBtn from './private-component/PaySuccessBtn'

export default {
  data() {
    return {
      isActive: true,
      isPassed: true,
      orderCode: '',
      order: {},
      showConfig: {
        showPlatform: false,
        showOrderList: true,
        showAppstore: false
      }
    }
  },
  methods: {
    init(ordercode) {
      $.get('/order/orderdetail', {
        ordercode: ordercode
      }).then((res) => {
        this.order = res.order
      })
    }
  },
  components: {
    PaySuccessBtn,
  },
  mounted() {
    this.orderCode = this.$route.params.ordercode.split("&")[0];
    this.init(this.orderCode)
  }
}
</script>
<style scoped>
.success-con {
  font-size: 12px;
  width: 100%;
}

.success-box {
  border: 1px solid #ccc;
  padding: 30px 0 0 0;
  margin: 120px 0;
}

.s-tip {
  position: relative;
  text-align: center;
  margin: 0 0 50px 0;
}

.s-tip i {
  font-size: 24px;
  color: #1ab52d;
  margin: 0 10px 0 0;
}

.s-tip span {
  display: inline-block;
  font-size: 24px;
  color: #f87500;
  height: 24px;
  line-height: 24px;
}

.item-line {
  font-size: 14px;
  margin: 15px 0;
  width: 100%;
}

.b-button {
  width: 150px;
  height: 36px;
  line-height: 36px;
  color: #0085d0;
  border: 1px solid #0085d0;
  text-align: center;
  border-radius: 3px;
  margin-top: 10px;
  cursor: pointer;
}

.time-line {
  border-top: 1px dashed #eee;
  padding: 20px 0 50px 0;
  margin: 20px 0 0 0;
}

.success-wrap {
  width: 800px;
  margin: 0 auto;
  padding: 120px 0;
  text-align: center;
}

.suc-icon {
  height: 40px;
  line-height: 40px;
  text-align: center;
  display: inline-block;
}

.suc-icon i {
  font-size: 40px;
  color: #20b09f;
  margin: 0 20px 0 0;
}

.iconfont {
  font-size: 14px;
}

.contact-info {
  text-align: left;
  border-left: 1px solid #ccc;
  margin: 60px 0 0 0;
  padding: 0 0 0 120px;
}
</style>



// WEBPACK FOOTER //
// src/Payment/components/PaySuccess.vue